export default __webpack_public_path__ + "static/media/Logo colombia cientifica.9843539c.jpeg";